import styled from 'styled-components';
import { FlexCenterAligned } from '../../styled/common';
import { Breakpoints } from '../../styled/constants';

const getPaddingTop = ($isWebView: boolean) =>
  $isWebView ? 'calc(25px + max(env(safe-area-inset-top), 40px))' : '25px';

export const AuthWrapper = styled(FlexCenterAligned)<{ $isWebView: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  z-index: 100002;
  -webkit-backface-visibility: hidden;
  background-color: ${({ theme }) => theme.colors.background.primary};
  padding-top: ${({ $isWebView }) => getPaddingTop($isWebView)};

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    background-color: rgba(0, 0, 0, 0.5);
    padding-top: 0;
  }
`;

export const Iframe = styled.iframe<{ $isWebView: boolean }>`
  width: 100vw;
  height: ${({ $isWebView }) => `calc(100dvh - ${getPaddingTop($isWebView)})`};
  border: 0;

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    width: 430px;
    height: 300px;
    position: relative;
    background: white;
    padding: 20px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  }
`;
